export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		horizontal: 1,
		vertical: 1,
	},
	LIST: {
		columns: {
			id: 'ID',
			name: 'Exploração',
			description: 'Descrição',
			horizontal: 'Horizontal',
			vertical: 'Vertical',
		},
		rows: [],
	} 
}